import { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { EventContext } from "components/event/EventContext";
import { serviceActionCapture } from "services/graphql/call";

export const useMainRedirect = (props) => {
  const user = props.user;
  const location = useLocation();
  const eventContext = useContext(EventContext);

  const [redirect, setRedirect] = useState(null);

  // if not connected capture url for redirect on connect
  useEffect(() => {
    const captureRedirect = async (extendedPath) => {
      let redirectPath = location.pathname;
      if (extendedPath === "launchpad") {
        extendedPath = null;
      }
      if (extendedPath === "tickets") {
        extendedPath = "offertypes";
      }
      if (extendedPath) {
        redirectPath += "/" + extendedPath;
      }
      await serviceActionCapture({
        type: "redirect",
        path: redirectPath,
      });
      setRedirect(location.pathname);
    };
    if (!user.connected) {
      if (eventContext) {
        if (
          eventContext.state.event.hydrated &&
          !eventContext.state.event.exploring
        ) {
          captureRedirect(eventContext.state.event.moduleSelected);
        }
      } else {
        captureRedirect();
      }
    }
  }, [user.connected, location.pathname, eventContext]);

  return redirect;
};

// USAGE
// useMainRedirect(props);
// const redirect = useMainRedirect(props);
